import { render } from "./ActiveIcon.vue?vue&type=template&id=8bbe02d8&scoped=true&ts=true"
import script from "./ActiveIcon.vue?vue&type=script&lang=ts"
export * from "./ActiveIcon.vue?vue&type=script&lang=ts"

import "./ActiveIcon.vue?vue&type=style&index=0&id=8bbe02d8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bbe02d8"]])

export default __exports__